import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PillCaption, Colours } from '@ratehub/base-ui';


function PFAWinnerPill() {
    return (
        <PillCaption
            className="rh-my-0_25 rh-mx-0"
            backgroundColour={Colours.BLUEBERRY_LIGHTEST}
            message={(
                <FormattedMessage
                    id="web-components.deposits.pfa-winner"
                    defaultMessage="2023 Winner!"       // requires yearly updating in our translation system
                />
            )}
        />
    );
}


export default PFAWinnerPill;
